// IronVeil Landing Page JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Thumbnail image switcher ─────────────────────────────
  document.querySelectorAll('.iv-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var target = document.getElementById(this.dataset.target);
      if (target) {
        target.style.opacity = '0.5';
        target.src = this.dataset.full;
        target.onload = function () { target.style.opacity = '1'; };
      }
      var strip = this.closest('.iv-thumbnails');
      if (strip) strip.querySelectorAll('.iv-thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ── Purchase toggle (subscribe / one-time) ───────────────
  document.querySelectorAll('.iv-purchase-toggle').forEach(function (toggle) {
    toggle.querySelectorAll('.iv-toggle-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggle.querySelectorAll('.iv-toggle-btn').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  });

  // ── FAQ accordion ────────────────────────────────────────
  document.querySelectorAll('.iv-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.iv-faq-item');
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.iv-faq-item.open').forEach(function (i) { i.classList.remove('open'); });
      // Open clicked (unless it was already open)
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Variant button selection ─────────────────────────────
  document.querySelectorAll('.iv-variant-options').forEach(function (group) {
    group.querySelectorAll('.iv-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.iv-variant-btn').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  });

  // ── Sticky ATC bar — show after scrolling past buy box ───
  var stickyBar = document.querySelector('[id^="iv-sticky-"]');
  var buyBox = document.querySelector('.iv-hero-buybox');
  if (stickyBar && buyBox) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0.1 });
    observer.observe(buyBox);
  }

});
